<script setup lang="ts">

</script>

<template>
  <div class="mx-auto w-[calc(100%-40px)] 2xs:w-[min(90%,88.9vw)] 2k:w-[2048px] 4k:w-[2560px]">
    <slot />
  </div>
</template>

<style scoped lang="scss">

</style>
